// extracted by mini-css-extract-plugin
export default {"language":"LanguageSwitcher_language__nNrA-"};